import { CitiesResponse } from '@/core/domain/cities/models/cities.model';
import { CitiesRepository } from '@/core/domain/cities/repositories/cities.repository';
import { DestinationsResponse } from '@/core/domain/destinations/models/destinations.model';
import { DestinationsRepository } from '@/core/domain/destinations/repositories/destinations.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DestinationsImplRepository extends DestinationsRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getDestinations(): Observable<DestinationsResponse> {
        return this.httpClient
            .get<DestinationsResponse>(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.destinations,
                ].join('/'),
            )
            .pipe(
                switchMap((destinationsResponse: DestinationsResponse) => {
                    const destinations: DestinationsResponse = {
                        type: destinationsResponse.type,
                        action: destinationsResponse.action,
                        notifications: destinationsResponse.notifications,
                        data: destinationsResponse.data,
                    };

                    return of(destinations);
                }),
            );
    }
}
